<template>
	<div class="col-md-12 search result">
        <el-table
            ref="filterTable1"
            :data="this.displayDataVar"
            stripe
            show-summary
            :summary-method="this.footerMethod"
            :fit="true"
            v-loading="loading"
            :border="true"
            :show-header="true"
            :header-cell-style="{paddingTop: '8px', paddingBottom: '2px', paddingLeft: '0px', paddingRight: '0px', background: '#F5F7FA'}"
            :header-row-style="{padding:'0px'}"
            :cell-style="{padding: '4px 0px', borderBottom: '1px solid #EBEEF5', borderRight: '0px solid #EBEEF5'}"
            @sort-change="sortChange"
            @header-click="headerClick"
            @row-click="onselectrow"
            style="width: 100%;"
            class="no-border"
            width="100%"
            id="table">

            <el-table-column
                v-for="(item, index) in this._reportdata['columns']" :key="index"
                :prop="item.field"
                :label="item.title"
                sortable ="custom"
                :resizable="true"
                :sort-orders="['ascending', 'descending']"

                :min-width="item.columnWidth == 'auto' ? '200px' : item.columnWidth + 'px'"
                :width="item.columnWidth == 'auto' ? '200px' : item.columnWidth + 'px'"
                :formatter="(row, column, cellValue, index) => formatter(row, column, cellValue, index, item.format)"
                :align="item.format == 'number' || item.format == 'percent' || item.format == 'decimal' ? 'right' : 'left'"
                header-align="center">

            </el-table-column>
            <!--
                :min-width="'100px'"
                :width="(item.field.length * 9) + 50 + 'px'"

                :sort-method="(a,b) => sortListMethod(a, b, item.field)"
                :sort-orders="['ascending', 'descending', null]"
            -->

        </el-table>

        <div class="mt-0 pt-3 mb-2 pb-0" style="text-align: left; background:white;" v-if="!loading && issuccess">
            <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                @current-change="handleCurrentChange"
                @size-change="changePerPage"
                @currentPage="tableProperties.currentPage"
                :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
                :page-size="tableProperties.pageSize"
                :total="tableProperties.total">
            </el-pagination>
        </div>

		<div class="toolbox" v-if="rows.length && !noxls">
			<vue-excel-xlsx class="btn icon btn-light btn-secondary justify-content-center"
				:data="dataXLSX"
				:columns="columnXLSX"
				:file-name="reportname"
				:sheet-name="'Data'"
				>
				<i class="far fa-file-excel"></i>
			</vue-excel-xlsx>
		</div>
	</div>
</template>

<script>

import tableMixin from '../../mixins/table'
import '../../plugins/table.js'
import { AxiosWithJar } from '@/utility.js'

import Vue from 'vue'
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);

//table ref:
//https://element.eleme.io/#/en-US/component/table

export default
{
    mixins: [tableMixin],
	components: {
        //BootstrapTable,
	},
	props:['reporturl', 'reportdata', 'reportname', 'rowtemplates', 'nopage', 'card_title', 'noxls', 'select_url', 'idcol', 'loading', 'issuccess', 'footerMethod'],
	data() {
		return {
			reportdata_:[],
            tableProperties: {
				filtered: [],
				search: '',
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
            sort: {
                property: '',
                order: 'null',
            },
            displayDataVar : [],
            columnWidth: 200,
            isLoaded: false,
		}
	},
	watch:{
		reporturl(now) {
			AxiosWithJar().get(now).then((response)=>{
				this.reportdata_ = response.data;
			})
		},

        reportdata() {
            this.clearSort()
            this.displayData2()
        },

	},
	computed:{
		_reportdata() {
			return this.reportdata ? this.reportdata : this.reportdata_;
		},
		columns() {
			let cols=[];
			if (this._reportdata['columns']) {
				let columns = this._reportdata['columns'];
				for(var i=0; i<columns.length; i++){
					if (columns[i].format != 'hidden') {
						cols.push({
							title: columns[i].title,
							field: columns[i].field,
							sortable: true,
							align: columns[i].format == 'number' || columns[i].format == 'percent' ? "right" : "left",
							valign: "middle",
							sorter: columns[i].format == 'number' || columns[i].format == 'percent' ? this.numericOnly : this.alphanum, //'numericOnly',
                            //checkbox: true,
                            //rowspan: 2,
                            //colspan: 3,
							//row_classes:"", //unused
							//column_classes:"", //unused
						});
					}
				}
			}
			//console.log('cols: '+JSON.stringify(cols));
			return cols;
		},
		rows(){
			let rows=[];
			if (this._reportdata['columns']) {
				let columns = this._reportdata['columns'];
				let data = this._reportdata['data'];
				for	(var j=0; j<data.length; j++) {
					let row={}
					for (var i=0; i<columns.length; i++){
						let a = data[j][columns[i].field]
						if (columns[i].format == 'number') a = this.formatNum(a * 1);
						if (columns[i].format == 'percent') a = this.formatNum(a * 100) + "%";
						row[columns[i].field] = a
						//console.log('log: ' + a);
					}
					rows.push(row)
				}
			}
			return rows;
		},
        displayData() {
            return this.displayData2()
        },
		columnXLSX()
		{
			let labels=[];
			if (this._reportdata['columns']) {
				let columns = this._reportdata['columns'];
				for(var i=0; i<columns.length; i++){
					let dt = {}
					dt['field'] = columns[i].field;
					dt['label'] = columns[i].title;
					labels.push(dt);
				}
			}
			return labels;
		},
		dataXLSX(){
			let rows=[];
			if (this._reportdata['columns']) {
				rows = this._reportdata['data'];
			}
			return rows;
		},

	},
	mounted(){
		if (this.card_title) {
			this.table.config.card_mode = true;
			this.table.config.card_title = this.card_title;
		}
        this.displayData2()


	},
	methods:{
        displayData2() {
            let tableData = this._reportdata['data']
            if(tableData !== undefined) {
                //set column width:
                /*
                let columnCount = this._reportdata['columns'].length
                let tableWidth = this.$refs.filterTable1.$el.clientWidth
                if(this.isLoaded == false) {
                    if(tableWidth > 650) {
                        this.columnWidth = Math.round(tableWidth/columnCount);
                    } else {
                        this.columnWidth = 150
                    }
                }
                this.isLoaded = true
                */


                if(this.tableProperties.search == null) return tableData;

                //console.log('sortProperty ' + this.sort.property)
                //console.log('sortOrder ' + this.sort.order)
                if(this.sort.property !== undefined && this.sort.order !== undefined) {
                    if(this.sort.order == 'ascending') {
                        tableData.sort(this.dynamicSort(this.sort.property));
                    } else if(this.sort.order == 'descending') {
                        tableData.sort(this.dynamicSort('-'+this.sort.property));
                    }
                }
                this.tableProperties.filtered = tableData //tableData.filter(data => !this.tableProperties.search || data.storeName.toLowerCase().includes(this.tableProperties.search.toLowerCase()));
                this.tableProperties.total = this.tableProperties.filtered.length;

                let result = this.tableProperties.filtered.slice(this.tableProperties.pageSize * this.tableProperties.currentPage - this.tableProperties.pageSize, this.tableProperties.pageSize * this.tableProperties.currentPage)
                this.displayDataVar = result
                return result
            }
            else
                return [];
        },
		onselectrow(a) {
            //console.log('on row click '+ JSON.stringify(a))
			if (this.idcol) {
				if(this.select_url) window.open(this.select_url + a[this.idcol],'_blank')
			}
		},

        handleCurrentChange(val) {
            this.tableProperties.currentPage = val;
            this.displayData2()
        },

        changePerPage(val) {
            this.tableProperties.pageSize = val
            this.displayData2()
        },

        //FORMATTER
        formatter(row, column, cellValue, index, format) {
            //let val = (row[column.property]/1).toFixed(2).replace('.', ',')
            //let result = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")

            let result = row[column.property] //if number then auto number
            if(format == 'decimal')
                result = this.formatterDecimal(result)
            else if(format == 'number')
                result = this.formatterDecimal(result) //this.formatterNumber(result)
            else if(format == 'percent')
                result = this.formatterPercent(result)

            return result //((row[column.property])/1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },
        formatterDecimal(value) {
            //let valueDecimal = value.toFixed(2) //parseFloat(value.toString().replace(',', '.'))
            let val = (value/1).toFixed(2).replace('.', ',')
            let result = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            //console.log('formatterDecimal: ' + result)
            return result
        },
        formatterNumber(value) {
            return parseInt(value)
        },
        formatterPercent(value) {
            let val = ((value/1)*100).toFixed(2).replace('.', ',')
            let result = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            return result + '%'
        },
        //END FORMATTER

        //SORT
        sortListMethod(a, b, key) {
            //ref:
            //https://github.com/ElemeFE/element/pull/12410
            //return parseInt(a) - parseInt(b)
            //return this.toFloat(a.TotalSalesExTax) - this.toFloat(b.TotalSalesExTax)
            //console.log('sorted: ' + key)
            return this.toFloat(a[key]) - this.toFloat(b[key])
        },
        toFloat(num) {
            return parseFloat((num+'').replace('.','').replace(',','.'))
            //return parseInt((num+'').replace('.','').replace(',',''))
        },
        sortAlpha(a,b, key) {
            if (a[key].toUpperCase() <  b[key].toUpperCase()) return -1;
            if (a[key].toUpperCase() > b[key].toUpperCase()) return 1;
            return 0;
        },
        //END SORT

        //CUSTOM SORT
        sortChange(sortProps){
            this.headerClick(sortProps.column,event)
            //console.log("sortChange: " + JSON.stringify(sortProps))
        },
        headerClick(column, event){
            //console.log("Header clicked: " + JSON.stringify(column))
            this.sort.order = column.order
            this.sort.property = column.property
            this.displayData2()
        },

        clearSort() {
            //console.log('this.$refs.filterTable1', this.$refs.filterTable1);
            this.$refs.filterTable1.clearSort();
            // this.$refs.filterTable1.clearSort('date');
            // this.$refs.filterTable1.clearSort('name');
        },

        dynamicSort(property) {
            var sortOrder = 1;
            if(property[0] === "-") {
                sortOrder = -1;
                property = property.substr(1);
            }
            return function (a,b) {
                /* next line works with strings and numbers,
                * and you may want to customize it to your needs
                */

                let valueA = (a[property]+'').replace('.','').replace(',','.')
                let valueB = (b[property]+'').replace('.','').replace(',','.')


                //default: for string
                var result = ( valueA < valueB) ? -1 : (valueA > valueB) ? 1 : 0;

                //if number/float
                if(/^-?\d+$/.test(valueA) && /^-?\d+$/.test(valueB)) {
                    let aa = parseFloat(a[property]).toFixed(2)
                    let bb = parseFloat(b[property]).toFixed(2)
                    //console.log('valueA: ' + aa + '-' + bb) //parseFloat(valueA).toFixed(2)
                    //result = (parseInt(valueA) < parseInt(valueB)) ? -1 : (parseInt(valueA) > parseInt(valueB)) ? 1 : 0;
                    result = (parseFloat(aa) < parseFloat(bb)) ? -1 : (parseFloat(aa) > parseFloat(bb)) ? 1 : 0;
                }
                return result * sortOrder;
            }
        },
        //END CUSTOM SORT


	}
}
</script>

<style>
.b4-table {
}
.search.result { margin-top:10px; background:rgba(20,109,182,.0275); border-radius:5px 5px ; color:#666; padding:0px;   }
.search.result .toolbox {
    z-index: 99;
    position: fixed;
    bottom: 25px;
    right: 25px;
    display: flex; background: rgba(255,255,255,.75);
    border-radius: 25px;
}
.search.result .toolbox button { display: flex;
    font-size: 12px;
    align-items: center; background: rgba(20,109,182,.75) !important; color:#fff;
    border-radius: 15px;
}
.search.result .toolbox .btn.icon {
    padding:15px; margin: 10px;
}
.no-border {
    border: 0px solid #fff !important;
}

</style>
